"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _GoogleDocs = _interopRequireDefault(require("composer-lib/data/model/GoogleDocs"));

var _immutable = require("immutable");

var _constants = require("composer-lib/lib/constants");

var _default = function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new _GoogleDocs.default();
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_PENDING:
      return state.set('tokenRequestStatus', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_SUCCEEDED:
      return _GoogleDocs.default.fromJS(action.data);

    case _ActionTypes.default.FETCH_GOOGLE_ACCESS_TOKEN_FAILED:
      return state.set('tokenRequestStatus', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.IMPORT_GOOGLE_DOC_PENDING:
      return state.set('importStatus', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.IMPORT_GOOGLE_DOC_SUCCEEDED:
      return state.set('importStatus', _constants.RequestStatus.UNINITIALIZED);

    case _ActionTypes.default.IMPORT_GOOGLE_DOC_FAILED:
      return state.set('importStatus', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_PENDING:
      return state.set('accountsRequestStatus', _constants.RequestStatus.PENDING);

    case _ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_SUCCEEDED:
      return state.merge({
        accounts: new _immutable.List(action.data),
        accountsRequestStatus: _constants.RequestStatus.SUCCEEDED
      });

    case _ActionTypes.default.FETCH_GOOGLE_ACCOUNTS_FAILED:
      return state.set('accountsRequestStatus', _constants.RequestStatus.FAILED);

    case _ActionTypes.default.UPDATE_GOOGLE_ACCOUNT:
      return state.merge({
        email: action.data.email,
        token: action.data.accessToken
      });

    default:
      return state;
  }
};

exports.default = _default;
module.exports = exports.default;